import { Component, AfterViewInit, ViewChild, Inject } from '@angular/core';
import { InsuranceService } from "../Service/Insurance.Service";
import { InsuranceDataModel } from "../../model/index"
import { Title } from '@angular/platform-browser';
import { ModalComponent } from "../../shared/modeldialog/index";
import { SecurityService } from '../../Security/security.service';
import { Router } from "@angular/router";
declare var Insurancegridself: any;

declare var require: any;
declare var InsuranceGrid: any;
@Component({
    selector: 'MentisSoft-Insurance',
    template: require('../Template/Insurance.template.html'),
   // styles: [require('../Template/Insurance.css')]
})

export class InsuranceComponent implements AfterViewInit {
    @ViewChild("viewModelPopup") viewModelPopup: ModalComponent;
    loading = false;
	CurrencyValue: string;
    constructor( @Inject(SecurityService) private _SecurityService: SecurityService, private _InsuranceService: InsuranceService, private _titleService: Title,
        private router: Router) {
        InsuranceGrid = this;
		this.CurrencyValue = localStorage.getItem("CurrencySymbol");
    }

    dataSource: InsuranceDataModel[] = [];
    columns: any[] = [];

    ngAfterViewInit(): void {
        $('#overlay').hide();
        this._titleService.setTitle("Insurance Reports");
        this.LoadAlergyReports();
    }

    showBookingSlots() {
        this.viewModelPopup.open();
    }

    LoadAlergyReports() {
        this.loading = true;
        this._InsuranceService.getInsuranceReports(this._SecurityService.pid, this._SecurityService.authentication, this._SecurityService.pid, this._SecurityService.IsAdminUser)
            .subscribe(
            p => {
                if (p.sessionExpiry && p.SessionTimeout != "Session Expired") {
                    this.loading = false;
                    this.dataSource = p.InsuranceReports;
                    this.buildGrid();
                    this._SecurityService.errorMessage = "";
                }
                else if(!p.sessionExpiry || p.SessionTimeout == "Session Expired") {
                    this._SecurityService.errorMessage = "Your session has expired. Please login again.";
                    this.router.navigate(["/Login"]);
                }
            },
            err => {
                this.loading = false;
                console.log("Error while validating...");
            });
    }

    public buildGrid() {
        try {
            this.buildColumn();

            var dgrid = jQuery("#grdInsuranceResults").data("kendoGrid");
            if (dgrid) {
                $('#grdInsuranceResults').data().kendoGrid.destroy();
                $('#grdInsuranceResults').empty();
            }
            jQuery('#grdInsuranceResults').kendoGrid({
                editable: false,
                filterable: true,
                pageable: {
                    pageSizes: [10, 25, 50, 100]
                },
                scrollable: false,
                sortable: true,
                
                columns: this.columns,

                
                dataBinding: this.databinding,
               
                dataSource: {
                    data: this.dataSource,
                    
                    pageSize: this.dataSource != null ? 10 : 0,
                    
                },
            });
            jQuery("#grdInsuranceResults").data("kendoGrid").wrapper.children(".k-grid-pager").find("span.k-input").html('All');
            var gridPage = jQuery("#grdInsuranceResults").data("kendoGrid");
            gridPage.wrapper.children(".k-grid-pager").find("span.k-input").html('10');
            var pageSizeDropDownList = gridPage.wrapper.children(".k-grid-pager").find("select").data("kendoDropDownList");
            pageSizeDropDownList.bind("change", function (e: any) {
                gridPage.wrapper.children(".k-grid-pager").find("span.k-input").html(gridPage.wrapper.children(".k-grid-pager").find("select").find('option:selected').text());
            });
        }
        catch (ex) {
            this.handleError(ex);
        }
    }

    buildColumn(): void {
        this.columns = [
            {
                field: "ReqDate",
                title: "Req.Date",
            },
            {
                field: "RecordName",
                title: "Services",
            },
            {
                field: "DoctorName",
                title: "Doctor",
            },
            {
                field: "Amount",
                title: "Req.Amount" + " " + "(" + this.CurrencyValue + ")",                
                attributes: {
                  
                    "class": "text-right"
                }
            },
            {
                field: "ApprovedAmount",
                title: "Approved Amount" + " " + "(" + this.CurrencyValue + ")",                
                attributes: {
                    "class": "text-right",
                  
                }
            },
            {
                field: "Status",
                title: "Status",
                template: kendo.template("#=this.changeTemplate(Status)#").bind(this)               
            }
        ];
    }

    changeTemplate(value) {
        var strtemp;
        if (value == "Accepted") {
            strtemp = " <span class='confirm-txt' > "+ value + "</span ></div>"; 
        }
        if (value == "InProgress") {
            strtemp = " <span class='orng' >" + value + "</span ></div>"; 
        }
        else {
            strtemp = " <span class='waiting-txt' >" + value + "</span ></div>"; 
        }
        return strtemp;      
    }

    databinding(e: any) {
        try {
            var grid = jQuery("#grdInsuranceResults").data("kendoGrid");
            var totalCount = grid.dataSource.total();
            var pageSizes = [{ text: "10", value: 10 }, { text: "25", value: 25 }, { text: "50", value: 50 }, { text: "100", value: 100 }, { text: "All", value: totalCount }];
            var pagerdropdownBox = jQuery('.k-pager-sizes select[data-role="dropdownlist"]').data('kendoDropDownList');
            var pagerds = new kendo.data.DataSource({
                data: pageSizes
            });
            pagerdropdownBox.setDataSource(pagerds);
        }
        catch (e) {
           
        }
    }

    private handleError(error: any) {
        console.log("error : " + error);
    }
}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./app/Insurance/Component/Insurance.Component.ts